import { createSelector } from 'reselect'

const selector = state => state.loginReducer

export const loginLoadSelector = createSelector(
  [selector],
  ({ loading }) => loading
)

export const loginCurrenUserSelector = createSelector(
  [selector],
  ({ currentUser }) => currentUser
)

export const loginIsAuthSelector = createSelector(
  [selector],
  ({ didTryAutoLogin }) => didTryAutoLogin
)

export const loginSelector = createSelector(
  [selector],
  login => login
)
